/** @jsx jsx */
import { jsx } from '@emotion/react';

export const PurchaseCompleteIcon = (): JSX.Element => {
  return (
    <svg
      width="65"
      height="64"
      viewBox="0 0 65 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.592 56.8889C46.3378 56.8889 57.4809 45.7457 57.4809 32C57.4809 18.2542 46.3378 7.11108 32.592 7.11108C18.8463 7.11108 7.70312 18.2542 7.70312 32C7.70312 45.7457 18.8463 56.8889 32.592 56.8889ZM46.297 24.2379C47.1943 23.0701 46.9749 21.3959 45.8071 20.4986C44.6392 19.6013 42.9651 19.8207 42.0678 20.9885L28.8582 38.1811L22.9832 32.133C21.9571 31.0766 20.2688 31.0521 19.2124 32.0783C18.156 33.1045 18.1315 34.7927 19.1577 35.8491L27.1526 44.0796C28.3006 45.2614 30.2298 45.1496 31.2336 43.8431L46.297 24.2379Z"
        fill="#0F8514"
      />
    </svg>
  );
};
